import Cookies from 'js-cookie';

import {
  CANCEL_REGISTRATION,
  CLEAR_EASY_JOIN_ERROR,
  CLEAR_GOOGLE_ERROR,
  REGISTER_USER_START,
  REGISTER_USER_FULFILLED,
  REGISTER_USER_REJECTED,
  RESET_EASY_JOIN,
  SET_GOOGLE_USER,
  SET_REGISTERING_WITH_GOOGLE,
  SET_SUBMITTING,
  SUBMIT_EASY_JOIN_CODE_START,
  SUBMIT_EASY_JOIN_CODE_FULFILLED,
  SUBMIT_EASY_JOIN_CODE_REJECTED,
} from './actionTypes';

import { axiosLogin, axiosRegister } from '../../../shared/utils/setCommonHeaders';
import {
  authProvider, fetchLogin, saveAuthTokens,
} from '../../login/ducks/loginActions';
import { showErrorToast } from '../../../shared/utils/toastManager';

authProvider();

export const clearEasyJoinError = () => (
  {
    type: CLEAR_EASY_JOIN_ERROR,
  }
);

// Cancel registration, clear cookies (logout), and redirect to login page
export const cancelRegistration = (clearCookies) => (dispatch) => {
  dispatch({ type: CANCEL_REGISTRATION });
  // Clear SSO registration flag when cancelling
  sessionStorage.removeItem('isRegisteringWithSSO');
  if (clearCookies) {
    Cookies.remove('v2token', {
      secure: process.env.ENVIRONMENT !== 'LOCAL' && true,
      domain: process.env.ENVIRONMENT === 'LOCAL' ? 'localhost' : '.teambuildr.com',
    });
    Cookies.remove('accessToken', {
      secure: process.env.ENVIRONMENT !== 'LOCAL' && true,
      domain: process.env.ENVIRONMENT === 'LOCAL' ? 'localhost' : '.teambuildr.com',
    });
    Cookies.remove('refreshToken', {
      secure: process.env.ENVIRONMENT !== 'LOCAL' && true,
      domain: process.env.ENVIRONMENT === 'LOCAL' ? 'localhost' : '.teambuildr.com',
    });
    Cookies.remove('tokenExpiration', {
      secure: process.env.ENVIRONMENT !== 'LOCAL' && true,
      domain: process.env.ENVIRONMENT === 'LOCAL' ? 'localhost' : '.teambuildr.com',
    });
  }
  window.location.href = '/login';
};

// TODO: fix the 404 error on successful registration of existing users
// currentUser gets reset causing isregistered to be true and breakt the page
export const registerUser = (values) => (dispatch) => {
  dispatch({ type: REGISTER_USER_START });
  axiosRegister.post('/register', values)
    .then((response) => {
      const { data } = response.data;
      // Clear SSO registration flag on successful registration
      sessionStorage.removeItem('isRegisteringWithSSO');
      setTimeout(() => {
        dispatch({
          payload: { data },
          type: REGISTER_USER_FULFILLED,
        });
      }, 800);
      saveAuthTokens(
        data.v2_token,
        data.accessToken,
        data.refreshToken,
        data.expires_in,
      );
      dispatch(fetchLogin());
    })
    .catch((err) => {
      dispatch({
        payload: err,
        type: REGISTER_USER_REJECTED,
      });
      showErrorToast(err?.response?.headers?.message || 'Something went wrong, please try again.');
    });
};

export const resetEasyJoin = () => ({
  type: RESET_EASY_JOIN,
});

export const setGoogleError = (bool) => {
  if (bool) {
    showErrorToast('There was an error connecting with Google, please try again.');
  }
  return {
    type: CLEAR_GOOGLE_ERROR,
  };
};

export const setGoogleUser = (isRegistering) => ({
  payload: isRegistering,
  type: SET_GOOGLE_USER,
});

export const setRegisteringWithGoogle = (isRegistering) => ({
  payload: isRegistering,
  type: SET_REGISTERING_WITH_GOOGLE,
});

export const setSubmitting = (isSubmitting) => ({
  payload: isSubmitting,
  type: SET_SUBMITTING,
});

export const submitEasyJoinCode = (values) => (dispatch) => {
  dispatch({ type: SUBMIT_EASY_JOIN_CODE_START });
  axiosLogin
    .get(
      `/easy-joins?easyJoinCode=${values.easyJoinCode}&easyJoinPassword=${values.easyJoinPassword}`,
    )
    .then(async (response) => {
      if (response.data && response.data.length) {
        setTimeout(() => {
          dispatch({
            payload: response.data[0],
            type: SUBMIT_EASY_JOIN_CODE_FULFILLED,
          });
        }, 1000);
      } else {
        dispatch({
          payload:
            'The submitted Easy-Join code or password is invalid. Please try again.',
          type: SUBMIT_EASY_JOIN_CODE_REJECTED,
        });
      }
    })
    .catch((err) => {
      dispatch({
        payload: err,
        type: SUBMIT_EASY_JOIN_CODE_REJECTED,
      });
    });
};
